// extracted by mini-css-extract-plugin
module.exports = {"errorPanel":"ErrorPanel_errorPanel__1Cgsu","errorWrapper":"ErrorPanel_errorWrapper__2NSAf","close":"ErrorPanel_close__1lxZW"};